import { RegionAttachment, TextureAtlasRegion } from '@esotericsoftware/spine-threejs';
import { v4 as uuid } from 'uuid';

type CustomRegionAttachment = RegionAttachment & { region: TextureAtlasRegion }
type Props = { attachment: CustomRegionAttachment, width?: number, height?: number, maxWidth?: number, maxHeight?: number }

function Attachment({ attachment, width: propWidth, height: propHeight, maxHeight, maxWidth }: Props) {

  if(!attachment || !attachment.region || !attachment.region.page) {
    return null
  }

  const id = uuid()

  const { region: { x, y, height: imgHeight, width: imgWidth, u, v, u2, v2, page: { height: pageHeight, width: pageWidth } } } = attachment

  const aspect = (imgHeight/imgWidth)

  let height = imgHeight
  let width = imgWidth

  if(propWidth && !propHeight) {
    width = propWidth
    height = width * aspect
  } else if (propWidth && propHeight) {
    width = propWidth
    height = propHeight
  } else if(!propWidth && propHeight) {
    height = propHeight
    width = height * (1/aspect)
  }

  // apply max width / height ???
  if(maxHeight !== undefined && height > maxHeight) {
    height = maxHeight
    width = height * (1/aspect)
  }
  if(maxWidth !== undefined && width > maxWidth) {
    width = maxWidth
    height = width * aspect
  }


  const xScale = width / imgWidth
  const yScale = height / imgHeight

  return <>
  <div style={{position: 'relative', height, width, overflow: 'hidden'}}>
  <img
    alt=""
    src={`/assets/${attachment.region.page.name}`}
  style={{
    maxWidth: 'none',
    display: 'block',
    margin: 0,
    position: 'absolute',
    clipPath: `url(#${id}-clip-path)`,
    width: pageWidth*xScale,
    height: pageHeight*yScale,
    top: -y*yScale,
    left: -x*xScale,
    }} />
    </div>
    <svg width="0" height="0">
      <clipPath id={`${id}-clip-path`} clipPathUnits="objectBoundingBox">
        <polygon points={`
            ${u} ${v},
            ${u2} ${v},
            ${u2} ${v2},
            ${u} ${v2}
        `} />
      </clipPath>
    </svg>
  </>
}

export default Attachment